module.exports = {
    inputTypes: {
        // The Input Types used for questionsets can be configured with any type from the simpleDatatypeComponentMap e.g.
        // Boolean: 'radio'
    }
}